import React, { useEffect, useMemo, useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import styles from './style/index.module.less'
import SideBar from '../SideBar'
import { GlobalState } from '../../store'
import lazyload from '../../utils/lazyload'
import { useSelector, useDispatch } from 'react-redux'
import useRoute from '@/routes'
import { MENUS } from '@/share/config'
import Modal from '@/components/Modal/index'
import Header from '../Header'
import SideBar1 from '../SideBar1'
import '@/style/editorDefault.less'
import '@/style/lib.less'
import ShowQuickDrawer from '../Drawer/show-quick-drawer'
import { showModal } from '@/share/actions'

const Layout = () => {
  const { userInfo, theme } = useSelector((state: GlobalState) => state)
  const [headerVisible, setHeaderVisible] = useState(false)
  const [routes, defaultRoute] = useRoute(userInfo?.permissions)
  const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes])
  const dispatch = useDispatch()
  useEffect(() => {
    headerVisibleHandle()
  }, [])
  function getFlattenRoutes(routes) {
    const res = []
    function travel(_routes) {
      _routes.forEach((route) => {
        const visibleChildren = (route.children || []).filter(
          (child) => !child.ignore,
        )
        if (route.key && (!route.children || !visibleChildren.length)) {
          try {
            route.component = lazyload(() => import(`../../pages/${route.key}`))
            res.push(route)
          } catch (e) {
            console.error(e)
          }
        }
        if (route.children && route.children.length) {
          travel(route.children)
        }
      })
    }
    travel(routes)
    return res
  }
  useEffect(() => {
    if (window.location.pathname !== 'collect') {
      dispatch({
        type: 'update-theme',
        payload: { theme: 'light' },
      })
    }
  }, [window.location.pathname])
  const headerVisibleHandle = () => {
    MENUS.forEach((i) => {
      if (i.path == location.pathname) {
        setHeaderVisible(i.headerVisible)
      }
    })
  }
  useEffect(() => {
    headerVisibleHandle()
    if (location.hash == '#vip') {
      // showModal('VipContentModal')
    } else if (location.hash == '#addDocTem') {
      showModal('AddTemplateModal', {
        Modaltitle: '模版库新建文档',
        title: '模版库新建文档',
      })
    } else if (location.hash == '#FolderCoverModal') {
      showModal('FolderCoverModal', {
        Modaltitle: '新建图书',
        title: '',
      })
    }
  }, [])
  return (
    <div
      className={
        window.screen.width < 450 ? styles['phoneLayout'] : styles['pageLayout']
      }>
      <ShowQuickDrawer></ShowQuickDrawer>
      {window.screen.width < 450 ? (
        ''
      ) : (
        <div className={styles['sideNav']}>
          <SideBar></SideBar>
        </div>
      )}
      {window.screen.width < 450 ? (
        ''
      ) : (
        <div className={styles['header']}>
          <Header></Header>
        </div>
      )}
      <div
        className={`${styles['contain']} ${styles[theme]} ${
          window.screen.width < 450 && styles['contain-phone']
        }`}>
        <Switch>
          {flattenRoutes.map((route, index) => {
            return (
              <Route
                key={index}
                path={`/${route.key}`}
                component={route.component}
              />
            )
          })}
          <Route exact path="/">
            <Redirect to={`/${defaultRoute}`} />
          </Route>
          <Route
            path="*"
            component={lazyload(
              () => import('../../pages/exception/403/index'),
            )}
          />
        </Switch>
      </div>
      <Modal></Modal>
    </div>
  )
}

export default Layout
